import { CategoryService } from "@/services/categoryApi";

const initialState = () => ({categories: []});

export default {
	namespaced: true,

	state: initialState(),

	mutations: {
		resetState,
		setCategories
	},

	actions: {fetchCategories}
};

function resetState(state) {
	Object.assign(state, initialState());
}

function setCategories(state, categories) {
	state.categories = categories;
}

async function fetchCategories({commit}) {
	const {data} = await CategoryService.getCategories();
	commit("setCategories", data.groups.filter(group => group.name !== "error"));
}
